<template>
  <a-modal title="压力" :visible="showTubeView" width="60%" destroyOnClose @ok="closeTubeView" @cancel="closeTubeView"
    :centered="true" :bodyStyle="{ padding: '20px' }">
    <a-row>
      <a-col :md="24" :sm="24">
        <div class="data-card">
          <div class="data-content">
            <div class="data-fields">
              <div class="field-row">
                <div class="field-item">
                  <label>测点名称:</label>
                  <span class="field-value">{{ piezometer.geophysicalPointNumber || '--' }}</span>
                </div>
                <div class="field-item">
                  <label>安装地址:</label>
                  <span class="field-value">{{ piezometer.installAddress || '--' }}</span>
                </div>
              </div>
              <div class="field-row">
                <div class="field-item">
                  <label>SIM卡号:</label>
                  <span class="field-value">{{ piezometer.piezometerNo || '--' }}</span>
                </div>
                <div class="field-item">
                  <label>安装时间:</label>
                  <span class="field-value">{{ piezometer.installTime || '--' }}</span>
                </div>
              </div>
              <div class="field-row">
                <div class="field-item">
                  <label>压力值:</label>
                  <span class="pressure-value">{{ pressureData.pressure || '--' }}</span>
                </div>
                <div class="field-item">
                  <label>采集时间:</label>
                  <span class="field-value">{{ pressureData.collectTime || '--' }}</span>
                </div>
              </div>
            </div>
            <div class="query-section">
              <a-date-picker @change="onChange" format="YYYY-MM-DD" v-model="queryTime" placeholder="选择日期" />
              <a-button type="primary" @click="getDataList">查询</a-button>
            </div>
          </div>
        </div>
      </a-col>
      <a-col :md="24" :sm="24">
        <div v-if="loading" class="loading-wrapper">
          <a-spin size="large">
            <div class="loading-content">
              <div class="loading-text">数据加载中...</div>
            </div>
          </a-spin>
        </div>
        <div v-else-if="showNoData" class="no-data-wrapper">
          <a-empty description="数据缺失" />
        </div>
        <div v-else class="chart-container" :id="id" :data="option"></div>
      </a-col>
    </a-row>
  </a-modal>
</template>
<script>

import moment from 'moment'
import * as echarts from 'echarts'
import lineEchart from './modules/lineEchart.vue'
import { getUUID } from '../../../utils/util'

function GetDateStr (AddDayCount) {
  var dd = new Date()
  dd.setDate(dd.getDate() + AddDayCount) // 获取AddDayCount天后的日期
  var y = dd.getFullYear()
  var m = dd.getMonth() + 1 // 获取当前月份的日期
  var d = dd.getDate()
  if (m < 10) m = '0' + m
  if (d < 10) d = '0' + d
  return y + '-' + m + '-' + d
}
export default {
  components: {
    lineEchart,
    moment
  },
  data () {
    return {
      name: '',
      dateFormat: 'YYYY-MM-DD HH:mm:ss',
      queryUrl: '/pipe-network/pipes/analysis-of-tube-burst',
      dataList: [],
      queryTime: GetDateStr(0),
      contrastBeginTime: '',
      contrastEndTime: '',
      piezometer: {
        installAddress: '',
        installTime: '',
        piezometerNo: ''
      },
      pressureData: {
        collectTime: '',
        pressure: ''
      },
      showTubeView: false,
      showNoData: false,
      loading: false,
      id: getUUID(),
      option: {}
    }
  },
  methods: {
    moment,
    //    getCurrentData1() {
    //   return new Date().toLocaleDateString()
    // },
    // getCurrentData1() {
    //   return new Date().toLocaleDateString()
    // },
    onChange (date, dateString) {
      this.queryTime = dateString
    },
    edit (name) {
      this.piezometer = {
        installAddress: '',
        installTime: '',
        piezometerNo: ''
      }
      this.pressureData = {
        collectTime: '',
        pressure: ''
      }
      this.showTubeView = true
      this.name = name
      this.getDataList()
    },
    // 获取数据
    getDataList () {
      const params = {
        installAddress: this.name,
        time: this.queryTime
      }
      // 重置状态
      this.showNoData = false
      this.loading = true

      this.$http.get('/pipe-network/piezometer/analysis/statement/trend-analyse', { params }).then(({ data }) => {
        // 检查是否有数据返回
        if (!data || data.length === 0 || !data[0]) {
          this.loading = false
          this.showNoData = true
          return
        }

        console.log(data[0].today, '2345')
        const todayTime = data[0].today
        const yesterd = data[0].yesterday
        const beforeYest = data[0].beforeYesterday
        console.log(yesterd);
        const todayst = todayTime != null ? todayTime[0][0].strTime : null
        const todaysr = yesterd != null ? yesterd[0][0].strTime : null
        const todaysh = beforeYest != null ? beforeYest[0][0].strTime : null
        this.piezometer = data[0].piezometer
        this.pressureData = data[0].pressureData ? data[0].pressureData : { collectTime: '', pressure: '' }
        // 安全地获取数据，避免 null 错误
        const beforeYesterday = data[0].beforeYesterday && data[0].beforeYesterday[0] ? data[0].beforeYesterday[0] : []
        const yesterday = data[0].yesterday && data[0].yesterday[0] ? data[0].yesterday[0] : []
        const today = data[0].today && data[0].today[0] ? data[0].today[0] : []

        console.log(beforeYesterday, 'beforeYesterday')
        console.log('today length:', today.length)

        // 检查 today 数据是否为空
        if (today.length === 0) {
          console.log('显示数据缺失')
          this.loading = false
          this.showNoData = true
          return
        }
        const datas = [beforeYesterday, yesterday, today, data[0].highPressureValue, data[0].lowPressureValue]
        const names = [todaysh, todaysr, todayst, '压力上限', '压力下限']
        console.log(names);

        const series = []

        // 先构建 x 轴数据，使用所有有数据的时间点
        const allTimeData = []
        if (beforeYesterday.length > 0) {
          beforeYesterday.forEach(item => allTimeData.push(item.time))
        } else if (yesterday.length > 0) {
          yesterday.forEach(item => allTimeData.push(item.time))
        } else if (today.length > 0) {
          today.forEach(item => allTimeData.push(item.time))
        }

        for (let j = 0; j < 3; j++) {
          const sdata = []
          for (let i = 0; i < datas[j].length; i++) {
            sdata.push(datas[j][i].pressure)
          }
          const seriesData = {
            name: names[j],
            data: sdata,
            type: 'line',
            smooth: true,
            showSymbol: false, // 取消小圆点
            barWidth: 30,
            markPoint: {
              data: [
                { type: 'max', name: '最大值' },
                { type: 'min', name: '最小值' }
              ]
            }
          }
          series.push(seriesData)
        }

        // 添加压力上限和下限的标记线
        const highPressureValue = data[0].highPressureValue
        const lowPressureValue = data[0].lowPressureValue

        // 为第一个系列添加标记线
        if (series.length > 0) {
          series[0].markLine = {
            data: [
              {
                name: '压力上限',
                yAxis: highPressureValue,
                lineStyle: {
                  color: 'rgba(255, 77, 79, 0.3)',
                  type: 'dashed',
                  width: 2
                },
                label: {
                  formatter: '压力上限: {c}',
                  position: 'end',
                  show: true,
                  borderRadius: 4,
                  padding: [4, 8],
                  fontSize: 12,
                  color: 'rgba(255, 77, 79, 0.7)',
                  offset: [-100, -10]
                }
              },
              {
                name: '压力下限',
                yAxis: lowPressureValue,
                lineStyle: {
                  color: 'rgba(255, 77, 79, 0.3)',
                  type: 'dashed',
                  width: 2
                },
                label: {
                  formatter: '压力下限: {c}',
                  position: 'end',
                  show: true,
                  borderRadius: 4,
                  padding: [4, 8],
                  fontSize: 12,
                  color: 'rgba(255, 77, 79, 0.7)',
                  offset: [-100, 12]
                }
              }
            ]
          }
        }

        // 设置 x 轴数据
        const xData = allTimeData

        this.option = {
          color: ['#5470C6', '#91CC75', '#FAC859'],
          title: {
            subtext: 'Mpa',
            left: 'left'
          },
          // grid: {
          //   top: '80px',
          //   left: '60px',
          //   right: '83px',
          //   bottom: '80px',
          // },
          grid: {
            top: '70px',
            left: '2%',
            right: '2%',
            bottom: '50px',
            containLabel: true
          },
          toolbox: {
            top: 10,
            itemSize: 20,
            show: true,
            feature: {
              dataZoom: {
                yAxisIndex: 'none'
              },
              dataView: { readOnly: false },
              magicType: { type: ['line', 'bar'] },
              restore: {},
              saveAsImage: {}
            }
          },
          xAxis: {
            type: 'category',
            data: xData
          },
          yAxis: {
            type: 'value',
            max: function (value) {
              // 获取压力上限值
              const highPressureValue = data[0].highPressureValue;
              // 获取实际数据的最大值
              const dataMax = value.max;

              // 如果上限最高，就用上限的1.5倍，否则用数据最大值的1.5倍
              const targetMax = Math.max(highPressureValue, dataMax) * 1.5;

              // 四舍五入到小数点后一位
              return Math.round(targetMax * 10) / 10;
            },
            axisLabel: {
              formatter: function (value) {
                return value.toFixed(1);
              }
            }
          },
          dataZoom: [
            {
              type: 'slider', // 图表下方的伸缩条
              show: true, // 是否显示
              realtime: true, // 拖动时，是否实时更新系列的视图
              start: 0, // 伸缩条开始位置（1-100），可以随时更改
              end: 100 // 伸缩条结束位置（1-100），可以随时更改
            }
          ],
          tooltip: {
            trigger: 'axis'
          },
          series: series
        }
        this.drawLineGraph(this.id)
        this.loading = false
      })
      this.$nextTick(() => { })
    },
    drawLineGraph (id) {
      const _this = this
      console.log(this.option, this.id)

      // 确保 DOM 元素存在
      this.$nextTick(() => {
        const chartElement = document.getElementById(this.id)
        if (chartElement) {
          const myChart = echarts.init(chartElement)
          myChart.setOption(this.option)
          window.addEventListener('resize', function () {
            myChart.resize()
          })
        }
      })
    },
    closeTubeView () {
      this.showTubeView = false
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .ant-form-item {
  margin-bottom: 0px;
}

/deep/ .ant-modal-content {
  border-radius: 15px;
}

/deep/ .ant-modal-header {
  border-radius: 15px 15px 0 0;
}

/deep/ .ant-modal-footer {
  border-radius: 0 0 15px 15px;
}

.chart-container {
  width: 100%;
  height: 350px;
  margin: 10px 0;
  position: relative;
  box-sizing: border-box;
}

.chart-container>div {
  width: 100% !important;
  height: 100% !important;
  border-radius: 6px;
}

.data-card {
  background-color: #e6f7ff;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
}

.data-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.data-fields {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
}

.field-row {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  max-width: 500px;
}

.field-item {
  display: flex;
  align-items: center;
  flex: 1;
}

.query-section {
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  margin-left: 20px;
}

.field-item label {
  font-weight: 500;
  margin-right: 8px;
  color: #333;
  min-width: 60px;
}

.field-item span {
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 170px;
}

.field-value {
  font-weight: 600;
}

.pressure-value {
  color: #1890ff !important;
  font-weight: 600;
}

/deep/ .query-section .ant-btn {
  border-radius: 6px;
}

/deep/ .ant-calendar-picker-input {
  width: 250px !important;
  border-radius: 6px !important;
}

.loading-wrapper {
  width: 100%;
  height: 350px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 10px 0;
  position: relative;
  box-sizing: border-box;
  min-width: 400px;
}

.loading-content {
  text-align: center;
}

.loading-text {
  margin-top: 64px;
  color: #666;
  font-size: 14px;
}

.no-data-wrapper {
  width: 100%;
  height: 350px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 10px 0;
  position: relative;
  box-sizing: border-box;
}
</style>
